import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("locationGroup"),
            field: "group",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("groupAppearanceSequence"),
            field: "sequence",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("activeFemale"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("queryCode"),
            field: "code",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("visualizationRol"),
            field: "rolString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("markerScheme"),
            field: "markSchemeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("markerIcon"),
            field: "icon",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("labelAbbreviation"),
            field: "labelAbrev",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geoQuery],
        config: {
            headerName: getLocalizedString("showNameInScoreboard"),
            field: "showMarkerString",
            filter: "agTextColumnFilter",
        }
    },
]